import { render, staticRenderFns } from "./ImmovablesEdit.vue?vue&type=template&id=30201c2b&"
import script from "./ImmovablesEdit.vue?vue&type=script&lang=js&"
export * from "./ImmovablesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports